<template>
  <div>
    <img v-if="show && $point.no !== 'c22cde1e67c611e9ab49525400436b39'" src="https://qiniu.laway.cn/yn/2022/10/16/7de386fa4d2c11ed9d41b4055d0b07be.png" width="100%" class="grayscale" style="display:block;height:1rem" alt="">
    <img src="https://qiniu.laway.cn/yn/2024/07/29/3f7127344d4711ef99e4b4055d0b07be.png" width="100%" @click="$router.push('/post/66a6ec657edc01775c7ef196?title=中国共产党第二十届中央委员会第三次全体会议公')" class="grayscale" v-if="$point.no === 'c22cde1e67c611e9ab49525400436b39'" style="display:block;height:1rem" alt="">
    <header class="header_home">
      <div class="c-left">
        <img class="logo " :src="logourl">
        <img class="logo " v-if="pointConfig&&pointConfig.extralogo" :src="pointConfig.extralogo">
        <div class="qr grayscale showconsole">
          <img v-if="$config" :src="$config.web_qr_url" :alt="$config.web_qr_content" width="64" height="64">
          <div>
            <strong>云南掌上12348</strong>
            <p>关注微信公众号<br />获得更多法律服务</p>
          </div>
        </div>

        <div class="qr grayscale showconsole" v-if="qrurl">
          <img :src="qrurl" height="64" alt="">
        </div>
        <div class="phone grayscale ">
          <img src="/img/ui/home/phone_green.png" alt="">
          <div>
            <strong>12348</strong>
            <p>拨打电话免费咨询法律问题</p>
          </div>
        </div>
        <div class="performance grayscale">
          <router-link to="/performance/530000/9004" class="performance-item">
            <img src="/img/ui/home/manyi_assess.png" alt="">
          </router-link>
        </div>
        <div class="performance grayscale">
          <router-link to="/pufa?title=扫黑除恶&id=6972cc757edc0174c0ea9833" class="performance-item">
            <img src="/img/ui/home/crime_crackdown.png" alt="" class="crime-crackdown-img">
          </router-link>
        </div>
      </div>
      <div class="c-right grayscale">
        <div class="r-suggest" @click="$router.push('/suggest')">
          <img src="/img/ui/home/suggest.png" alt="建议反馈" class="suggest">
          <span>
            建议反馈
          </span>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    },
    logo: {
      type: String,
      default: ''
    }
  },
  computed: {
    pointConfig () {
      return this.$point && this.$point.config ? JSON.parse(this.$point.config) : {}
    },
    extConfig () {
      return this.$config && this.$config.extra_config ? JSON.parse(this.$config.extra_config) : {}

    },
    qrurl () {
      const extConfig = this.extConfig
      const code = this.$point.code
      return extConfig.config && extConfig.config[code] && extConfig.config[code].qr ? extConfig.config[code].qr : this.pointConfig.qr
    },
    logourl () {
      return this.pointConfig.logo || this.logo || '/img/ui/home/logo_yn.png'
    }
  }
}
</script>
<style lang="stylus" scoped>
.header_home {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0.6rem 0.42rem;

  .c-left {
    display: flex;
    align-items: center;
    color: #fff;

    .logo {
      margin-right: 0.3rem;
      flex-shrink: 0;
      height: 0.73rem;
    }

    .qr {
      display: flex;
      align-items: center;
      font-size: 0.14rem;

      img {
        margin-right: 0.15rem;
      }

      strong {
        display: block;
        font-size: 0.18rem;
        margin-bottom: 0.02rem;
      }
    }

    .phone {
      margin-left: 0.2rem;
      display: flex;
      align-items: center;
      font-size: 0.14rem;

      img {
        width: 0.6rem;
        margin-right: 0.14rem;
      }

      strong {
        font-size: 0.3rem;
        font-style: italic;
      }
    }

    .performance {
      margin-left: 0.2rem;

      a {
        display: block;
      }

      // 扫黑除恶图片固定尺寸，避免占用过大空间
      .crime-crackdown-img {
        width: 235px;
        height: 68px;
        display: block;
      }
    }
  }

  .c-right {
    display: flex;
    align-items: center;
    color: #e3edff;
    font-size: 0.18rem;

    .r-help, .r-suggest {
      display: flex;
      align-items: center;
    }

    .r-help {
      margin-right: 0.48rem;
    }

    img {
      margin-right: 0.1rem;

      &.help {
        width: 0.24rem;
      }

      &.suggest {
        width: 0.2rem;
      }
    }
  }
}
</style>
